import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {Button, Modal} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import {PopupForm} from './PopupForm';
import {PopupSendMessageProvider} from '../../context/PopupSendMessageContext';

export function PopupSendMessage(cellContent) {
  const disabledCondition = !(can('view', 'unpaidAgentsPage') && Boolean(cellContent));
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const prefix = 'unpaid-agents-popup-send-message';

  return (
    <>
      <Button
        className={`btn btn-icon btn-light btn-sm mx-3 custom-action-button ${disabledCondition ? 'disabled' : ''}`}
        title={intl.formatMessage({id: `${prefix}-header`, defaultMessage: "Send message to agent"})}
        onClick={handleShow}
      >
        <img src={toAbsoluteUrl('/media/svg/Mail_brandColor.svg')} alt="edit"/>
      </Button>
      <Modal show={show} onHide={handleClose} size={'lg'}>
        <Modal.Body>
          <PopupSendMessageProvider cellContent={cellContent}>
            <PopupForm
              cellContent={cellContent}
              handleClose={handleClose}
            />
          </PopupSendMessageProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}